import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import LoadingOverlay from '../../../../core/Loading/LoadingOverlay';
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 49,
      opacity: 0,
      animationName: '$fadeMeIn',
      animationDuration: '.4s',
      animationFillMode: 'forwards'
    },
    '@keyframes fadeMeIn': {
      from: {
        opacity: 0
      },
      '20%': {
        opacity: 0
      },
      to: {
        opacity: 1
      }
    },
    progress: {
      color: theme.getColor(theme.getStyle('Data.Grid').selectionColor),
      height: 2
    }
  };
}, {
  name: 'ECLoadingBar'
});

var LoadingBar = function LoadingBar(_ref) {
  var progress = _ref.progress,
      estimated = _ref.estimated,
      startedAt = _ref.startedAt;
  var classes = useStyles({});
  var defaultSpeed = 2; //percentages per second

  var defaultResolution = 50; //percentages changed by the user

  var defaultLastValue = {
    at: Date.now(),
    value: null
  };
  var value = typeof progress === 'number' ? progress : undefined;
  /**@type {import('@material-ui/core').LinearProgressProps["variant"]} */

  var variant = typeof progress === 'number' ? 'determinate' : 'indeterminate';

  if (progress === true && typeof estimated === 'number') {
    variant = 'determinate';
    value = 0;
    var estimateAppearsAs = estimated - 400;
    defaultSpeed = Math.max(0, 100 / (estimateAppearsAs / 1000));
    if (typeof startedAt !== 'undefined') defaultLastValue.at = startedAt;
    defaultLastValue.value = 0;
    value = 0;
  }

  var _React$useState = React.useState(value),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      crtValue = _React$useState2[0],
      setCrtValue = _React$useState2[1];

  var lastValue = React.useRef(defaultLastValue);
  var speed = React.useRef(defaultSpeed);
  var resolution = React.useRef(defaultResolution);
  React.useEffect(function () {
    var interval = null;

    if (typeof progress === 'number') {
      //simulate continuos values by interpolating
      interval = setInterval(function () {
        if (speed.current) {
          var elapsed = (Date.now() - lastValue.current.at) / 1000; //seconds
          //adapt speed according to resolution

          var shouldAdd = elapsed * speed.current;

          if (shouldAdd > resolution.current) {
            shouldAdd = resolution.current * 0.75;
          } else if (shouldAdd > resolution.current / 2) {
            shouldAdd = resolution.current * 0.6;
          }

          var shouldBe = lastValue.current.value + shouldAdd;
          setCrtValue(shouldBe);
        }
      }, 200);

      if (lastValue.current.value) {
        var elapsed = (Date.now() - lastValue.current.at) / 1000; //seconds

        var delta = Math.max(1, progress - lastValue.current.value); //percentages

        speed.current = delta / elapsed * 0.3; //stay behind

        resolution.current = delta;
      }

      lastValue.current = {
        value: progress,
        at: Date.now()
      };
      setCrtValue(0);
    } else {
      if (typeof estimated === 'number') {
        interval = setInterval(function () {
          var elapsed = (Date.now() - lastValue.current.at) / 1000; //seconds

          var shouldAdd = elapsed * speed.current;
          var shouldBe = (lastValue.current.value || 0) + shouldAdd;
          shouldBe = Math.min(95, shouldBe);
          setCrtValue(shouldBe);
        }, 100);
      } else {
        setCrtValue(undefined);
      }
    }

    return function () {
      if (interval) clearInterval(interval);
    };
  }, [progress, speed, resolution, lastValue, estimated]);
  return React.createElement(React.Fragment, null, React.createElement(LoadingOverlay, null), React.createElement("div", {
    className: classes.root
  }, React.createElement(LinearProgress, {
    variant: variant,
    value: crtValue,
    className: classes.progress
  })));
};

LoadingBar.defaultProps = {};
export default LoadingBar;